import featureNames from 'constants/feature_names';

angular.module('filters').filter('membershipPlanSequenceStartDate', ["$rootScope", "$filter", "Months", function($rootScope, $filter, Months) {
  return function(plan) {
    var day, month, period;
    if (plan.specified_start_date) {
      return $filter('date')(plan.specified_start_date);
    }
    if (plan.default_start_date_strategy === 'start_on_next_upcoming') {
      day = $filter('ordinalize')(plan.start_on_next_upcoming_day);
      month = plan.start_on_next_upcoming_month ? Months[plan.start_on_next_upcoming_month - 1][1] : 'any month';
      return `on the next ${day} day of ${month}`;
    }
    if (plan.default_start_date_strategy === 'start_relative_to_purchase_date') {
      period = $filter('pluralize')(plan.relative_start_date_unit, plan.relative_start_date_number, true);
      return `${period} after ${featureNames.SEQUENCE_LOWERCASE} step fires`;
    }
  };
}]);
